module.exports = {
  PORT: "4014",
  NODE_ENV: "staging",

  // NOTE: ticketing/backend endpoints below are placeholders — point these
  // at the real Topgolf Tournament 2026 API once it exists. The site builds
  // and runs without it; ticketing/payment screens simply have no live data
  // until these are wired up.
  SERVER_DEV_URL: "http://localhost:3123",
  SERVER_STAGING_URL: "https://api-topgolftournament.cloudxier.dev",
  SERVER_PROD_URL: "",

  SERVER_GOLF_PASS_DEV_URL: "http://localhost:3131",
  SERVER_GOLF_PASS_STAGING_URL: "https://api-topgolfpass.cloudxier.dev",
  SERVER_GOLF_PASS_PROD_URL: "",

  CLIENT_DEV_HOST: "localhost",
  CLIENT_STAGING_HOST: "topgolftournament.cloudxier.dev",
  CLIENT_PROD_HOST: "",

  CLIENT_DEV_URL: "http://localhost:3000",
  CLIENT_STAGING_URL: "https://topgolftournament.cloudxier.dev",
  CLIENT_PROD_URL: "",

  MAIN_WEBSITE_TITLE: "Topgolf Tournament 2026 | ",
  SITE_NAME: "Topgolf Tournament 2026",

  CLIENT_GOLF_PASS_DEV_URL: "http://localhost:3000",
  CLIENT_GOLF_PASS_STAGING_URL: "https://topgolfpass.cloudxier.dev",
  CLIENT_GOLF_PASS_PRODUCTION_URL: "",
};
